<template>
  <div class="pbd-wrap">
    <PBDLateralMenu :selected-pbd="selectedPBD" @change-pbd="changePBD" />
    <div id="pbd-cont" class="pbd-content has-side-bars">
      <StatisticsContent v-if="selectedPBD === 'stat_content'" />
      <StatisticsUse v-else-if="selectedPBD === 'stat_use'" />
      <ProfilesUse v-else-if="selectedPBD === 'profiles_use'" />
    </div>
  </div>
</template>
  
<script>
import PBDLateralMenu from './PBDLateralMenu.vue'
import StatisticsContent from './StatisticsContent.vue'
import ProfilesUse from './ProfilesUse.vue'
import StatisticsUse from './StatisticsUse.vue'
import device from '@/utils/device'
export default {
  components: { PBDLateralMenu, StatisticsContent, ProfilesUse, StatisticsUse },
  data() {
    return {}
  },
  computed: {
    selectedPBD() {
      if (this.$route.query?.type) {
        return this.$route.query.type
      }
      return 'stat_content'
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.resizeCalculation()
    })
    setTimeout(() => {
      this.resizeCalculation()
    }, 10)
  },
  created() {
    if (!this.$route.query.type) {
      this.$router.push({
        name: 'WebStats',
        query: {
          type: this.selectedPBD,
        },
      })
    }
  },
  methods: {
    resizeCalculation() {
      let lm = document.getElementById('pbd-lm').getBoundingClientRect()
      let cont = document.getElementById('pbd-cont').getBoundingClientRect()
      let head = document.getElementsByClassName('home-button')[0].getBoundingClientRect()
      if (device !== 'mobile') {
        if (lm.right > cont.left) {
          document.getElementById('pbd-cont').style.marginLeft = lm.right + 15 + 'px'
          document.getElementById('pbd-cont').style.width =
            'calc(100% - ' + (lm.right + 15 + 15) + 'px)'
        } else if (lm.right < head.left) {
          document.getElementById('pbd-cont').style.marginLeft = 'auto'
          document.getElementById('pbd-cont').style.width = '100%'
        }
      }
    },
    changePBD(val) {
      //router change op
      this.$router.push({
        name: 'WebStats',
        query: {
          type: val,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.pbd-wrap
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  .pbd-content
    padding-top: vw(50px)
    padding-bottom: vw(50px)

    .mobile &
      padding: vw(20px) 0
</style>
